define('Inspiredrooms.ei1.Main', [
    'Inspiredrooms.ei1.Main.View'
], function (
    InspiredroomsEi1MainView
) {
    'use strict';

    return {
        mountToApp: function (container) {
            var PageType = container.getComponent('PageType');

            PageType.registerPageType({
                name: 'meeting_rooms',
                routes: ['room','room/:roomtype'],
                view: InspiredroomsEi1MainView,
                defaultTemplate: {
                    name: 'meeting_rooms.tpl',
                    displayName: 'Meeting Rooms'
                }
            });
        }
    }
});
